/**
 * Instantes ISO da API (UTC após normalização no backend) comparados com
 * {@link Date.now} / nowMs do painel. Evita `BrazilDate.parseAsBrazil` em
 * strings com sufixo Z — reinterpreta o relógio e deixa o timer em 00:00.
 */
export function instantMs(iso: string | null | undefined): number | null {
  if (!iso) return null;
  const ms = new Date(iso).getTime();
  return Number.isNaN(ms) ? null : ms;
}

export function segundosDesdeInicio(
  inicioIso: string,
  nowMs: number
): number {
  const startMs = instantMs(inicioIso);
  if (startMs == null) return 0;
  return Math.max(0, Math.round((nowMs - startMs) / 1000));
}

export function segundosEntreInstantes(
  inicioIso: string,
  fimIso: string
): number {
  const startMs = instantMs(inicioIso);
  const endMs = instantMs(fimIso);
  if (startMs == null || endMs == null) return 0;
  return Math.max(0, Math.round((endMs - startMs) / 1000));
}
